/**
 * @fileoverview POST handler for the "/engagement/campaigns/:campaign_id/export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignIdExportCacheKeys } from "./constants";
import type {
  PostEngagementCampaignsCampaignIdExportProps,
  EngagementCampaignsCampaignIdExportResult,
} from "./types";

export const postEngagementCampaignsCampaignIdExport = reactQueryMutationAdapter(
  engagementCampaignsCampaignIdExportCacheKeys,
  (props: PostEngagementCampaignsCampaignIdExportProps): Promise<EngagementCampaignsCampaignIdExportResult> => {
    const payload: any = {
      app_group_id: props.appGroupId,
      custom_attributes: props.customAttributes ?? [],
      custom_events: props.customEvents ?? [],
      export_all_attributes: props.exportAllAttributes ?? false,
      only_email_addresses: props.onlyEmailAddresses ?? false,
    };

    if (props.exportPredictionScores) {
      payload.export_prediction_scores = props.exportPredictionScores;
    }

    return fetch(`/engagement/campaigns/${props.campaignId}/export`, "POST", payload);
  }
);
